import { cn } from '@dfh-corp-sites/ui/utils'
import React from 'react'

import RenderCleanHtml from '../../../components/RenderCleanHtml'
import { SanityParentProductFragment } from '../../../graphql/gatsby'
import {
  ConfigurableProductDetailsFragment,
  SimpleProductDetailsFragment,
} from '../../../graphql/magento'
import { useProductDescription } from '../../../lib/products/hooks/useProductDescription'
import { displayAttribute } from '../../../utils/itemTools'
import BlockContainer from './BlockContainer'

export interface ProductDescriptionTextProps {
  item: ConfigurableProductDetailsFragment
  selectedVariant: SimpleProductDetailsFragment | null | undefined
  sanityParentProduct?: SanityParentProductFragment | null
  sanityChildProduct?: NonNullable<SanityParentProductFragment['products']>[number] | null
  className?: string
}

const ProductDescriptionText: React.VFC<ProductDescriptionTextProps> = ({
  item,
  selectedVariant,
  sanityParentProduct,
  sanityChildProduct,
  className,
}) => {
  const description = useProductDescription({
    contextualDescription: sanityChildProduct?._rawContextualDescription,
    parentContextualDescription: sanityParentProduct?._rawContextualDescription,
    defaultDescription: sanityChildProduct?._rawDefaultDescription,
    parentDefaultDescription: sanityParentProduct?._rawDefaultDescription,
  })

  // Order of precedence for the descriptions:
  // 1. Contextual Child Description (Sanity)
  // 2. Default Child Description (Sanity)
  // 3. Contextual Parent Description (Sanity)
  // 4. Default Parent Description (Sanity)
  // 5. Short Description (Magento)

  return (
    <div className={cn('rich-text', className)}>
      {description ? (
        <BlockContainer content={description} />
      ) : (
        <RenderCleanHtml
          className="[&_li]:mb-1.5 [&_p]:mb-6 [&_ul]:mb-6 [&_ol]:mb-6"
          htmlString={displayAttribute({
            item: item.short_description,
            selectedVariant: selectedVariant?.short_description,
            attribute: 'html',
          })}
        />
      )}
    </div>
  )
}

export default ProductDescriptionText
